import { isMobile } from "react-device-detect"
import { Notas } from "../component/Notas"

export const Blogs = () => {
  return (
    <>
      {isMobile ? <IsMobileBlog/> : <IsPcBlog  />}
    </>
  )
}
const IsPcBlog  =()=>{
  return(
    <div className="bg-white pt-5"   style={{
      minWidth: '100%',
      minHeight: '100vh',
      fontSize: '20px'
    }}>
      <div className="bg-white">
        <Notas />
      </div>
    </div>
  )
}
const IsMobileBlog  =()=>{
  return(
    <div className="bg-white"   style={{
      minWidth: '100%',
      minHeight: '100vh',
      fontSize: '20px'
    }}>
      <div className="bg-white">
        <Notas />
      </div>
    </div>
  )
}